/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./createVersion.vue?vue&type=template&id=b91b6416&scoped=true&"
import script from "./createVersion.vue?vue&type=script&lang=js&"
export * from "./createVersion.vue?vue&type=script&lang=js&"
import style0 from "./createVersion.vue?vue&type=style&index=0&id=b91b6416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91b6416",
  null
  
)

export default component.exports